import axios from "./axios";

export const getFreeOnus = async () => {
  const response = await axios.get("/customers/onus-free");
  return response.data;
};

export const createCustomer = async (data) => {
  const response = await axios.post("/customers", data);
  return response.data;
};



export const getCustomers = async () => {
  // CORREGIDO: Cambiar /clientes por /customers
  const response = await axios.get("/customers");
  return response.data;
};


export const getCustomerById = async (id) => {
  const response = await axios.get(`/customers/${id}`);
  return response.data;
};

